// ABOUTME: Static mock context for the Skylegs → TechLog flight transformation, built from captured staging responses.
import { SkylegsToTechlogFlightInput } from './validation';

/**
 * Captured verbatim from GET /flights, GET /flights/{id}/users/agenda and
 * GET /organisations/active/users on the Skylegs staging tenant "Eagle"
 * (flight 197094, N111SK). The right-seat crew member and its organisation user
 * are the captured records with the second seat's ids, position and code, so the
 * mock covers both pilot slots.
 */
export const mockData: SkylegsToTechlogFlightInput = {
  skylegs: {
    flight: {
      id: 197094,
      mission_id: 83487,
      category_id: 18,
      aircraft_id: 11679,
      departure_id: 3624,
      arrival_id: 3566,
      alternate_id: null,
      alternate2_id: null,
      actual_arrival_id: 3566,
      number: 'EGL123',
      mission_flight_identifier: null,
      flight_number: null,
      pax: 4,
      actual_pax: 2,
      actual_cargo: null,
      status: 'READY',
      obt: '2020-12-09T07:30:06-06:00',
      ibt: '2020-12-09T10:29:06-06:00',
      calculation_method: 'great_circle',
      tot: '2020-12-09T07:35:06-06:00',
      ldt: '2020-12-09T10:24:06-06:00',
      delay: null,
      actual_est: null,
      actual_obt: null,
      actual_ibt: null,
      actual_tot: null,
      actual_ldt: null,
      actual_eqt: null,
      sign_in: null,
      sign_out: null,
      domestic_eet: null,
      air_distance: null,
      ground_distance: null,
      actual_distance: null,
      block_fuel: null,
      planned_fuel: '1500.00',
      actual_fuel: null,
      cruise_level: 410,
      crew_string: 'BOB MSC',
      remarks: null,
      handover: null,
      notes: null,
      atl_number: '214',
      created_by: 2114,
      updated_by: 6,
      deleted_by: null,
      processed_at: null,
      deleted_at: null,
      created_at: '2020-12-08T07:41:05-06:00',
      updated_at: '2020-12-18T09:10:13-06:00',
      tentative_times: false,
      tentative_pax: false,
      client_id: 71327,
      publish: true,
      empty_leg: false,
      shared_leg: false,
      category: { id: 18, name: 'Commercial' },
      arrival: { id: 3566, icao: 'KHOU', name: 'William P Hobby' },
      actual_arrival: { id: 3566, icao: 'KHOU', name: 'William P Hobby' },
      departure: { id: 3624, icao: 'KTEB', name: 'Teterboro' },
      alternate: null,
      alternate2: null,
      aircraft: { id: 11679, registration: 'N111SK' },
      tags: [],
    },
    crew: [
      {
        id: 883725,
        user_id: 6304,
        mission_id: 83487,
        category_id: 18,
        agendable_id: 197094,
        agendable_type: 'MissionFlight',
        start: '2020-12-09T07:30:00-06:00',
        end: '2020-12-09T09:00:00-06:00',
        homebase_id: 3624,
        pilot_flying: true,
        pilot_in_command: true,
        eodp: false,
        duty: true,
        flightduty: true,
        sign_in: null,
        sign_out: null,
        ks_scale: null,
        passport_id: 73792,
        passport2_id: 73792,
        position: 'left',
        kind: 'Commander',
        available: false,
        temporary: false,
        title: 'Commercial',
        remarks: null,
        created_by: 2114,
        updated_by: 2114,
        deleted_by: null,
        created_at: '2020-12-08T08:52:10-06:00',
        updated_at: '2020-12-09T10:01:31-06:00',
        deleted_at: null,
        sort_key: 1,
        pilot_takeoff: false,
        iapi_status: null,
        iapi_message: null,
        sanctions_status: null,
        sanction_factor: null,
        category: { id: 18, name: 'Commercial' },
        homebase: { id: 3624, icao: 'KTEB', name: 'Teterboro' },
      },
      {
        id: 883726,
        user_id: 2114,
        mission_id: 83487,
        category_id: 18,
        agendable_id: 197094,
        agendable_type: 'MissionFlight',
        start: '2020-12-09T07:30:00-06:00',
        end: '2020-12-09T09:00:00-06:00',
        homebase_id: 3624,
        pilot_flying: false,
        pilot_in_command: false,
        eodp: false,
        duty: true,
        flightduty: true,
        sign_in: null,
        sign_out: null,
        ks_scale: null,
        passport_id: null,
        passport2_id: null,
        position: 'right',
        kind: 'Copilot',
        available: false,
        temporary: false,
        title: 'Commercial',
        remarks: null,
        created_by: 2114,
        updated_by: 2114,
        deleted_by: null,
        created_at: '2020-12-08T08:52:10-06:00',
        updated_at: '2020-12-09T10:01:31-06:00',
        deleted_at: null,
        sort_key: 2,
        pilot_takeoff: true,
        iapi_status: null,
        iapi_message: null,
        sanctions_status: null,
        sanction_factor: null,
        category: { id: 18, name: 'Commercial' },
        homebase: { id: 3624, icao: 'KTEB', name: 'Teterboro' },
      },
    ],
    organisationUsers: [
      {
        id: 6304,
        first_name: 'Bob',
        middle_name: null,
        last_name: 'Bobson',
        status: 'active',
        pivot: {
          code: 'BOB',
          status: 'active',
          email: 'bob@skylegs.com',
          homebase_id: 3624,
        },
      },
      {
        id: 2114,
        first_name: 'Maxim',
        middle_name: null,
        last_name: 'Schelfhout',
        status: 'active',
        pivot: {
          code: 'MSC',
          status: 'active',
          email: 'maxim+1@skylegs.com',
          homebase_id: 3624,
        },
      },
    ],
  },
};
